import * as React from 'react';
import { flow } from 'lodash';
import { Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { bindActionCreators } from 'redux';
import { IStore } from '../../../../redux/IStore';
import { reduxForm, formValueSelector } from 'redux-form';
import { IAuthState } from '../../../../services/auth/models';
import ForgottenPasswordForm from './components/ForgottenPasswordForm';
import { actions as authActions, IAuthActions } from '../../../../services/auth/reducer';

interface IForgottenPasswordProps {
  auth: IAuthState;
  actions: {
    auth: IAuthActions;
    push: (route: string) => void;
  };
}

class ForgottenPassword extends React.Component<IForgottenPasswordProps> {
  private handleSubmit = (values) => {
    const { actions } = this.props;
    actions.auth.forgottenPassword(values.email);
  }

  public render() {
    const { auth } = this.props;

    return (
      <Row className="page-container animated fadeIn">
        <div className="customer-section-title">
          <h1>Mot de passe oublié</h1>
          {!auth.resetPassword && (
            <h4>Veuillez compléter les informations ci-après afin de réinitialiser votre mot de passe</h4>
          )}
        </div>
        {!auth.resetPassword ? (
          <ForgottenPasswordForm onSubmit={this.handleSubmit}/>
        ) : (
          <div className="blue-section">
            <p>
              Un mail vient de vous être adressé afin de réinitialiser votre mot de passe.
              Si ce mail ne vous est pas parvenu dans les 5 prochaines minutes, nous vous invitons
              à vérifier votre dossier « courriers indésirables ».
            </p>
            <p>
              <u>Important</u> : le lien contenu dans le mail expirera dans 1 heure.
            </p>
          </div>
        )}
      </Row>
    );
  }
}

let selector;

export default flow([
  reduxForm({
    form: 'forgotten_password',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
  }),
  (component) => {
    selector = formValueSelector('forgotten_password');

    return component;
  },
  connect(
    (state: IStore) => {
      return {
        auth: state.auth,
      };
    },
    (dispatch) => ({
      actions: {
        push: bindActionCreators(push, dispatch),
        auth: bindActionCreators({ ...authActions }, dispatch),
      },
    }),
  ),
])(ForgottenPassword);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/CustomerArea/scenes/ForgottenPassword/index.tsx